<template>
  <md-toolbar class="flex-column flex-lg-row align-items-center">
    <div class="flex-row d-flex align-items-center mt-2 mt-lg-0">
      <md-icon>place</md-icon>
      <h5 class="mb-0 mt-0 ml-1">Você foi identificado como cliente, e será redirecionado em {{ tempo }}...</h5>
    </div>
    <div class="d-none d-lg-flex flex-grow-1"></div>
    <div class="d-flex align-self-end mb-2 mb-lg-0 flex-row align-items-center">
      <md-progress-spinner :md-diameter="30" md-mode="determinate" :md-value="tempo * 10"></md-progress-spinner>
      <md-button class="md-dense md-primary" @click="cancelar">Cancelar</md-button>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  name: "RedirectBottonBar",
  data() {
    return {
      tempo: 1,
      blocked: false
    };
  },
  created() {
    let interval = setInterval(() => {
      this.tempo--;

      if (this.blocked) {
        clearInterval(interval);
      }

      if (this.tempo <= 0) {
        clearInterval(interval);
        this.$emit("handleTimeEnd");
      }
    }, 1000);
  },
  methods: {
    cancelar() {
      this.blocked = true;
      this.$emit("handleCancel");
    }
  }
};
</script>

<style scoped>
</style>
